import React, { ReactNode } from 'react';

import { StyledNavAvatar } from './SessionNavAvatar.styles';

interface SessionNavAvatarProps {
    children: ReactNode;
}

export const SessionNavAvatar = (props: SessionNavAvatarProps) => {
    return <StyledNavAvatar {...props}>{props.children}</StyledNavAvatar>;
};
